import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-green-50 py-16 sm:py-24" data-id="element-214">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="max-w-2xl mx-auto text-center flex flex-col items-center gap-6" data-id="element-216">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center border-2 border-green-200" data-id="element-217">
            <ShieldIcon className="w-10 h-10 text-green-600" data-id="element-218" />
          </div>

          <div data-id="element-219">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-220">
              Pruébalo 90 Días Sin Riesgo
            </h2>
            <p className="mt-4 text-lg text-muted-foreground leading-relaxed" data-id="element-221">
              Si no estás satisfecha/o, te devolvemos tu dinero. Sin
              complicaciones.
            </p>
          </div>

          <div className="bg-card rounded-2xl border border-green-200 p-6 w-full shadow-sm" data-id="element-222">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center" data-id="element-223">
              <div className="flex flex-col items-center gap-2" data-id="element-224">
                <span className="text-2xl font-bold text-green-600" data-id="element-225">90</span>
                <span className="text-sm text-muted-foreground" data-id="element-226">
                  Días de garantía
                </span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-227">
                <span className="text-2xl font-bold text-green-600" data-id="element-228">100%</span>
                <span className="text-sm text-muted-foreground" data-id="element-229">
                  Reembolso completo
                </span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-230">
                <span className="text-2xl font-bold text-green-600" data-id="element-231">0</span>
                <span className="text-sm text-muted-foreground" data-id="element-232">Preguntas</span>
              </div>
            </div>
          </div>

          <p className="text-sm text-muted-foreground max-w-md" data-id="element-233">
            Simplemente contáctanos dentro de los 90 días desde tu compra y
            procesaremos el reembolso sin ningún tipo de complicación.
          </p>

          <div className="w-full mt-4 bg-card border border-green-200 rounded-2xl overflow-hidden shadow-sm max-w-xl mx-auto" data-id="element-234">
            <div className="flex flex-col sm:flex-row items-center gap-0" data-id="element-235">
              <div className="w-full sm:w-44 flex-shrink-0" data-id="element-236">
                <img src="https://cdn.magicpatterns.com/uploads/u6Kjbkf7MsymGLXXBCFBYZ/ChatGPT_Image_Feb_27,_2026,_08_39_00_PM.png" alt="Doctor con Trimora GLP-1+NAD+" className="w-full h-52 sm:h-full object-cover object-top" data-id="element-237" />
              </div>
              <div className="flex flex-col gap-3 p-6" data-id="element-238">
                <span className="inline-flex items-center gap-1.5 bg-green-100 text-green-700 text-xs font-semibold px-2.5 py-1 rounded-full w-fit" data-id="element-239">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-240">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-241" />
                  </svg>
                  Avalado por profesionales de la salud
                </span>
                <blockquote className="text-foreground text-base leading-relaxed italic" data-id="element-242">
                  "Lo que más valoro de Trimora es su formulación. Ingredientes
                  naturales con mecanismo de acción claro. Mis pacientes
                  reportan menos antojos desde la primera semana."
                </blockquote>
                <div data-id="element-243">
                  <p className="font-semibold text-foreground text-sm" data-id="element-244">
                    Dr. Carlos Mendoza
                  </p>
                  <p className="text-muted-foreground text-xs" data-id="element-245">
                    Endocrinólogo — 15 años de experiencia clínica
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}